import gsap from 'gsap';

// import CSSRulePlugin from 'gsap/CSSRulePlugin';
// import CustomEase from 'gsap/CustomEase';
import Draggable from 'gsap/Draggable';
// import EaselPlugin from 'gsap/EaselPlugin';
// import EasePack from 'gsap/EasePack';
// import Flip from 'gsap/Flip';
import MotionPathPlugin from 'gsap/MotionPathPlugin';
// import Observer from 'gsap/Observer';
// import PixiPlugin from 'gsap/PixiPlugin';
// import ScrollToPlugin from 'gsap/ScrollToPlugin';
import ScrollSmoother from 'gsap/ScrollSmoother';
import ScrollTrigger from 'gsap/ScrollTrigger';
// import TextPlugin from 'gsap/TextPlugin';

gsap.registerPlugin(Draggable);
gsap.registerPlugin(MotionPathPlugin);
gsap.registerPlugin(ScrollSmoother);
gsap.registerPlugin(ScrollTrigger);
window.gsapPlugins = {
  Draggable,
  MotionPathPlugin,
  ScrollSmoother,
  ScrollTrigger
};
window.gsap = gsap;